import { IIconBase } from '..'

const checkInputIcon = ({
  color = '#198754',
  height = 18,
  width = 18,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icon-wrapper'>
        <path
          id='Union'
          d='M5.17454 15.1417L1.34954 10.1917C0.449542 7.85167 2.38454 7.04167 3.82454 8.39167L6.29954 11.5417L13.9495 2.99167C15.2995 1.57417 17.5495 2.38417 16.6495 4.56667L7.64954 14.9167C6.68204 16.0417 5.84954 15.8167 5.17454 15.1417Z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export default checkInputIcon
